module.exports = __webpack_public_path__ + "img/1_seguridad.9b44f567.svg";